module.exports = __webpack_public_path__ + "files/d57660ddadf9541fb327e46af57105eb.png";